import { NavigationTextLink } from '../side-bar/NavigationLink'
import { Column } from '../common/pure/FlexContainer'
import Heading from '../common/pure/Heading'
import PrimeIcon from '../common/pure/PrimeIcon'
import { FlowCardStepData } from './FlowCardStepData'

type FlowCardSideBarItemState = 'selected' | 'disabled' | 'completed'

interface FlowCardSideBarProps {
    title: string
    icon: PrimeIconName
    steps: FlowCardStepData[]
    onStepClick: (index: number) => void
    currentStepIndex: number
}
export default function FlowCardSideBar({
    title,
    icon,
    steps,
    onStepClick,
    currentStepIndex,
}: FlowCardSideBarProps) {
    const getMenuItemState = (index: number) => {
        if (index === currentStepIndex) return 'selected'
        if (index < currentStepIndex) return 'completed'
        else if (index > currentStepIndex) return 'disabled'
        else {
            console.warn(`Menu item with index ${index} not found.`)
            return undefined
        }
    }
    return (
        <Column gap={0.5}>
            <PrimeIcon name={icon} size={32} />
            <Heading size={3}>{title}</Heading>
            {steps.map((step, i) => (
                <FlowCardSideBarItem
                    key={step.key}
                    state={getMenuItemState(i)}
                    title={step.label}
                    onClick={() => onStepClick(i)}
                />
            ))}
        </Column>
    )
}

interface FlowCardSideBarItemProps {
    state?: FlowCardSideBarItemState
    title: string
    onClick: () => void
}
const FlowCardSideBarItem = ({ state, title, onClick }: FlowCardSideBarItemProps) => (
    <NavigationTextLink
        onClick={onClick}
        text={title}
        caret={state === 'completed'}
        strike={state === 'completed'}
        disabled={state === 'disabled'}
        selected={state === 'selected'}
        icon={state === 'completed' ? 'check-circle' : 'circle'}
    />
)
